var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var Asset3DController = /** @class */ (function () {
    function Asset3DController() {
    }
    /*****************************************************************************************************
        * Is using route "api/asset3d" and http method "GET" to call the back-end.
    
        * @returns {Asset3DDownloadDto}
    ******************************************************************************************************/
    Asset3DController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset3d", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/asset3d" and http method "POST" to call the back-end.
    
        * @returns {Asset3DUploadDto}
    ******************************************************************************************************/
    Asset3DController.Post = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset3d", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/asset3d" and http method "POST" to call the back-end.
    
        * @returns {Asset3DUploadDto}
    ******************************************************************************************************/
    Asset3DController.Patch = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset3d", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return Asset3DController;
}());
export { Asset3DController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=Asset3DController.js.map